// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"f2643c66","274":"2c48688c","743":"73cebb1c","767":"73f3898f","781":"da65bd14","931":"0a293d12","993":"73cebb1c"}[chunkId] + ".css";
};